// 产品状态
export const productStatusList = [
  { title: '已上线', name: 'online' },
  { title: '已下线', name: 'offline' },
  { title: '临时产品', name: 'temporaryProduct' }
]

// 品牌系列
export const productBrandList = [
  { title: '品牌管理', name: 'brandManage' },
  { title: '系列管理', name: 'seriesManage' },
  { title: '操作日志', name: 'operationLog' }
]

// 产品属地
export const productTerritoryList = [
  { productTerritory: '国产', title: '国产' },
  { productTerritory: '进口', title: '进口' },
  { productTerritory: '未知', title: '未知' }
]

// 产品类型
export const productList = [
  { proType: 1, title: '标准产品' },
  { proType: 2, title: '组合产品' }
]

// 是否停产
export const statusList = [
  { isStop: 0, title: '已停产' },
  { isStop: 1, title: '未停产' }
]

// 品类
export const pcNameList = [
  { label: '低压配电', value: 'pcName' }
]

// 添加产品品类
export const pcList = [
  {
    label: '电气、电工、自动化、照明',
    value: 'generalCategory',
    children: [
      {
        label: '低压配电',
        value: 'low-voltage',
        children: [
          {
            label: '变压器',
            value: 'transformer'
          }
        ]
      },
      {
        label: '负荷隔离开关',
        value: 'switch'
      },
      {
        label: '空气断路器',
        value: 'breaker'
      }
    ]
  }
]
// 物流方式
export const logisticsModeList = [
  { label: '快递配送', value: 1 },
  { label: '物流配送', value: 2 },
  { label: '客户自提', value: 3 },
  { label: '仓库送货', value: 4 }
]
// 快递公司,物流公司
export const expressCompanyList = [
  { label: '请选择', value: 1 },
  { label: '顺丰速递', value: 2 },
  { label: '中通', value: 3 }
]
// 提货人
export const consigneeLinkList = [
  { label: '请选择', value: 1 },
  { label: '客户自提', value: 2 },
  { label: '销售自提', value: 3 }
]
// 物流费用
export const logisticsFeesList = [
  { label: '合同结算', value: 1 },
  { label: '客户承担', value: 2 }
]
// 货期
export const deliveryTimeList = [
  { label: '2-3周', value: 1 },
  { label: '3-4周', value: 2 },
  { label: '2-8周', value: 3 }
]
// 产品选型模拟数据
export const parameterList = [
  {
    label: '级数1:',
    isParameterMore: false, // 系列更多
    parameterListValue: [
      { label: '施耐德', isActive: false },
      { label: '施耐德', isActive: false },
      { label: '施耐德', isActive: false },
      { label: '施耐德', isActive: false },
      { label: '施耐德', isActive: false },
      { label: '施耐德', isActive: false },
      { label: '施耐德', isActive: false },
      { label: '施耐德', isActive: false },
      { label: '施耐德', isActive: false },
      { label: '施耐德', isActive: false },
      { label: '施耐德', isActive: false },
      { label: '施耐德', isActive: false },
      { label: '施耐德', isActive: false },
      { label: '施耐德', isActive: false }
    ]
  },
  {
    label: '级数2:',
    isParameterMore: false, // 系列更多
    parameterListValue: [
      { label: '施耐德', isActive: false },
      { label: '施耐德', isActive: false },
      { label: '施耐德', isActive: false },
      { label: '施耐德', isActive: false },
      { label: '施耐德', isActive: false },
      { label: '施耐德', isActive: false },
      { label: '施耐德', isActive: false },
      { label: '施耐德', isActive: false },
      { label: '施耐德', isActive: false },
      { label: '施耐德', isActive: false },
      { label: '施耐德', isActive: false },
      { label: '施耐德', isActive: false },
      { label: '施耐德', isActive: false },
      { label: '施耐德', isActive: false }
    ]
  },
  {
    label: '级数3:',
    isParameterMore: false, // 系列更多
    parameterListValue: [
      { label: '施耐德', isActive: false },
      { label: '施耐德', isActive: false },
      { label: '施耐德', isActive: false },
      { label: '施耐德', isActive: false },
      { label: '施耐德', isActive: false },
      { label: '施耐德', isActive: false },
      { label: '施耐德', isActive: false },
      { label: '施耐德', isActive: false },
      { label: '施耐德', isActive: false },
      { label: '施耐德', isActive: false },
      { label: '施耐德', isActive: false },
      { label: '施耐德', isActive: false },
      { label: '施耐德', isActive: false },
      { label: '施耐德', isActive: false }
    ]
  },
  {
    label: '级数4:',
    isParameterMore: false, // 系列更多
    parameterListValue: [
      { label: '施耐德', isActive: false },
      { label: '施耐德', isActive: false },
      { label: '施耐德', isActive: false },
      { label: '施耐德', isActive: false },
      { label: '施耐德', isActive: false },
      { label: '施耐德', isActive: false },
      { label: '施耐德', isActive: false },
      { label: '施耐德', isActive: false },
      { label: '施耐德', isActive: false },
      { label: '施耐德', isActive: false },
      { label: '施耐德', isActive: false },
      { label: '施耐德', isActive: false },
      { label: '施耐德', isActive: false },
      { label: '施耐德', isActive: false }
    ]
  },
  {
    label: '级数5:',
    isParameterMore: false, // 系列更多
    parameterListValue: [
      { label: '施耐德', isActive: false },
      { label: '施耐德', isActive: false },
      { label: '施耐德', isActive: false },
      { label: '施耐德', isActive: false },
      { label: '施耐德', isActive: false },
      { label: '施耐德', isActive: false },
      { label: '施耐德', isActive: false },
      { label: '施耐德', isActive: false },
      { label: '施耐德', isActive: false },
      { label: '施耐德', isActive: false },
      { label: '施耐德', isActive: false },
      { label: '施耐德', isActive: false },
      { label: '施耐德', isActive: false },
      { label: '施耐德', isActive: false }
    ]
  }
]
// 产品选型产品信息模拟数据
export const proAllContent = [
  {
    title: 'NSX塑壳配电保护断路器',
    product: '施耐德施耐耐耐',
    series: 'NBM23456543',
    proModel: 'FGHJ7876541234',
    orderNumber: 'DFGHJD',
    parameterListValue: [
      { label: '施耐德:', value: '维度值' },
      { label: '施耐德:', value: '维度值' },
      { label: '施耐德:', value: '维度值' },
      { label: '施耐德:', value: '维度值' },
      { label: '施耐德:', value: '维度值' },
      { label: '施耐德:', value: '维度值' },
      { label: '施耐德:', value: '维度值' }
    ]
  },
  {
    title: 'NSX塑壳配电保护断路器',
    product: '施耐德施耐耐耐',
    series: 'NBM23456543',
    proModel: 'FGHJ7876541234',
    orderNumber: 'DFGHJD',
    parameterListValue: [
      { label: '施耐德:', value: '维度值' },
      { label: '施耐德:', value: '维度值' },
      { label: '施耐德:', value: '维度值' },
      { label: '施耐德:', value: '维度值' },
      { label: '施耐德:', value: '维度值' },
      { label: '施耐德:', value: '维度值' },
      { label: '施耐德:', value: '维度值' }
    ]
  },
  {
    title: 'NSX塑壳配电保护断路器',
    product: '施耐德施耐耐耐',
    series: 'NBM23456543',
    proModel: 'FGHJ7876541234',
    orderNumber: 'DFGHJD',
    parameterListValue: [
      { label: '施耐德:', value: '维度值' },
      { label: '施耐德:', value: '维度值' },
      { label: '施耐德:', value: '维度值' },
      { label: '施耐德:', value: '维度值' },
      { label: '施耐德:', value: '维度值' },
      { label: '施耐德:', value: '维度值' },
      { label: '施耐德:', value: '维度值' }
    ]
  },
  {
    title: 'NSX塑壳配电保护断路器',
    product: '施耐德施耐耐耐',
    series: 'NBM23456543',
    proModel: 'FGHJ7876541234',
    orderNumber: 'DFGHJD',
    parameterListValue: [
      { label: '施耐德:', value: '维度值' },
      { label: '施耐德:', value: '维度值' },
      { label: '施耐德:', value: '维度值' },
      { label: '施耐德:', value: '维度值' },
      { label: '施耐德:', value: '维度值' },
      { label: '施耐德:', value: '维度值' },
      { label: '施耐德:', value: '维度值' }
    ]
  },
  {
    title: 'NSX塑壳配电保护断路器',
    product: '施耐德施耐耐耐',
    series: 'NBM23456543',
    proModel: 'FGHJ7876541234',
    orderNumber: 'DFGHJD',
    parameterListValue: [
      { label: '施耐德:', value: '维度值' },
      { label: '施耐德:', value: '维度值' },
      { label: '施耐德:', value: '维度值' },
      { label: '施耐德:', value: '维度值' },
      { label: '施耐德:', value: '维度值' },
      { label: '施耐德:', value: '维度值' },
      { label: '施耐德:', value: '维度值' }
    ]
  },
  {
    title: 'NSX塑壳配电保护断路器',
    product: '施耐德施耐耐耐',
    series: 'NBM23456543',
    proModel: 'FGHJ7876541234',
    orderNumber: 'DFGHJD',
    parameterListValue: []
  }
]
